<template>
    <nav class="navbar" role="navigation" aria-label="main navigation" :style="navStyles">
        <!-- Left side of navbar -->
        <div class="navbar-brand">
            <a class="no-pad navbar-item" href="/"><img :src="imagePath"/></a>
            <a
                role="button"
                class="navbar-burger"
                aria-label="menu"
                aria-expanded="false"
                @click="onBurgerClick"
                :class="{ 'is-active': isOpen, white: white }"
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>

        <!-- Right side of navbar -->
        <div class="navbar-menu" :class="{ 'is-active': isOpen }">
            <div class="navbar-end">
                <div class="navbar-item">
                    <a class="navtext" @click="toggleRatingModal">Rate a Class</a>
                </div>
                <div class="navbar-item">
                    <a class="navtext" target="_blank" href="https://forms.gle/egsbkbSQS3QPXhDD9">Give us Feedback</a>
                </div>

                <!-- Log in and Sign up buttons if user is logged out -->
                <div class="navbar-end" v-if="currentUser == null">
                    <div class="navbar-item">
                        <a class="navtext" @click="toggleLoginModal">Log in</a>
                    </div>
                    <div class="navbar-item">
                        <a class="navtext" @click="toggleSignUpModal">Sign up</a>
                    </div>
                </div>

                <!-- Link to the profile page -->
                <div class="navbar-end" v-else>
                    <div class="navbar-item">
                        <span class="helper"></span>
                        <img id="profilePic" :src="currentUser.photoURL" />
                        <router-link to="/u/" class="navtext">{{ currentUser.displayName }}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <RatingSelectionModal :isOpen="ratingModalOpen" v-on:toggleModal="toggleRatingModal" />
        <LoginModal
            ref="loginModal"
            :isOpen="loginModalOpen"
            @toggleModal="toggleLoginModal"
            @authUpdate="setCurrentUser"
        />
        <LoginModal
            ref="signUpModal"
            display="signUp"
            :isOpen="signUpModalOpen"
            @toggleModal="toggleSignUpModal"
            @authUpdate="setCurrentUser"
        />
    </nav>
</template>

<script>
import RatingSelectionModal from "@/components/modals/RatingSelectionModal";
import LoginModal from "@/components/modals/LoginModal";

// libraries
import { auth } from "@/firebase.js";

export default {
    name: "Navbar",
    props: {
        white: Boolean,
        backgroundColor: String,
        showLoginModal: {
            type: Boolean,
            default: false
        }
    },
    components: {
        RatingSelectionModal,
        LoginModal,
    },
    methods: {
        onBurgerClick() {
            this.isOpen = !this.isOpen;
            this.$emit("menu-click", this.isOpen);
        },
        toggleRatingModal() {
            this.ratingModalOpen = !this.ratingModalOpen;
        },
        toggleLoginModal() {
            this.signUpModalOpen = false;
            this.loginModalOpen = !this.loginModalOpen;
            this.$refs.loginModal.$forceUpdate();
        },
        toggleSignUpModal() {
            this.loginModalOpen = false;
            this.signUpModalOpen = !this.signUpModalOpen;
            this.$refs.signUpModal.$forceUpdate();
        },
        setCurrentUser(user) {
            this.currentUser = user;
        },
    },
    computed: {
        navStyles() {
            var textColor = "";
            var backgroundColor = "";

            if (this.isOpen) {
                textColor = "#000000";
            } else {
                textColor = this.textColor;
            }

            if (this.backgroundColor) {
                backgroundColor = this.backgroundColor;
            }

            return {
                "--text-color": textColor,
                "background-color": backgroundColor,
            };
        },
    },
    data() {
        const imagePath = this.white
            ? require("@/assets/branding/classy-white.svg")
            : require("@/assets/branding/classy-black.svg");
        const textColor = this.white ? "#FFFFFF" : "#000000";

        return {
            imagePath: imagePath,
            textColor: textColor,
            isOpen: false,
            ratingModalOpen: false,
            loginModalOpen: this.showLoginModal,
            signUpModalOpen: false,
            currentUser: auth.currentUser,
        };
    },

    mounted() {
        auth.onAuthStateChanged((user) => {
            if (user) {
                this.currentUser = user;
            } else {
                this.currentUser = null;
            }
        });
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.helper {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
}

#profilePic {
    padding: 1px 10px;
    max-height: 20px;
    max-width: 20px;
    vertical-align: middle;
}

.navbar {
    padding: 30px 0;
    background: None;
}

.navtext {
    font-size: 16px;
    color: var(--text-color);
    text-decoration: none;
    cursor: pointer;

    &:hover {
        color: #666;
    }
}

.no-pad {
    padding: 0px;
}

.white {
    color: white;
}

@media only screen and (max-width: $breakpoint-small) {
    .navbar,
    .navbar-item {
        margin-left: 0;
        padding-right: 10px;
    }
}
</style>
